// src/components/facility/DeskObject.js
import React from 'react';

function PhoneShape() {
  return (
    <div style={{ position: 'relative', width: 64, height: 64 }}>
      {/* Base */}
      <div style={{
        position: 'absolute', bottom: 0, left: 6, right: 6, height: 34,
        background: '#2a2016', borderRadius: 6,
        border: '1px solid #4a3820',
        boxShadow: '0 2px 6px rgba(0,0,0,0.6)',
      }} />
      {/* Handset */}
      <div style={{
        position: 'absolute', top: 6, left: 8, width: 48, height: 18,
        background: '#1e1810', borderRadius: 9,
        border: '1px solid #3a2814',
        transform: 'rotate(-12deg)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.5)',
      }} />
      {/* Dial ring */}
      <div style={{
        position: 'absolute', bottom: 6, left: 19, width: 26, height: 26,
        borderRadius: '50%', background: '#1a1410',
        border: '2px solid #3a2814',
      }} />
      {/* Dial hole */}
      <div style={{
        position: 'absolute', bottom: 12, left: 25, width: 14, height: 14,
        borderRadius: '50%', background: '#0e0c08',
      }} />
    </div>
  );
}

function LedgerShape() {
  return (
    <div style={{ position: 'relative', width: 64, height: 64 }}>
      {/* Book cover */}
      <div style={{
        position: 'absolute', top: 4, left: 10, right: 4, bottom: 2,
        background: '#2a1a0a', borderRadius: '2px 4px 4px 2px',
        border: '1px solid #5a3010',
        boxShadow: '0 2px 6px rgba(0,0,0,0.6)',
      }} />
      {/* Spine */}
      <div style={{
        position: 'absolute', top: 4, left: 4, width: 10, bottom: 2,
        background: '#1a0e05', borderRadius: '2px 0 0 2px',
        border: '1px solid #3a1e05',
        borderRight: 'none',
      }} />
      {/* Page lines */}
      {[14, 22, 30, 38, 46].map(top => (
        <div key={top} style={{
          position: 'absolute', top, left: 18, right: 8, height: 1,
          background: '#5a3510', opacity: 0.6,
        }} />
      ))}
      {/* Green column (money ledger) */}
      <div style={{
        position: 'absolute', top: 4, right: 4, width: 12, bottom: 2,
        background: 'rgba(0,80,20,0.3)',
        borderLeft: '1px solid #2a5a18',
      }} />
    </div>
  );
}

function ClipboardShape() {
  return (
    <div style={{ position: 'relative', width: 64, height: 64 }}>
      {/* Board */}
      <div style={{
        position: 'absolute', bottom: 2, left: 6, right: 6, top: 8,
        background: '#1e2010', borderRadius: 4,
        border: '1px solid #404228',
        boxShadow: '0 2px 6px rgba(0,0,0,0.6)',
      }} />
      {/* Metal clip */}
      <div style={{
        position: 'absolute', top: 2, left: '50%', transform: 'translateX(-50%)',
        width: 22, height: 10, background: '#555',
        borderRadius: '3px 3px 0 0',
        border: '1px solid #777',
      }} />
      {/* Clip opening */}
      <div style={{
        position: 'absolute', top: 4, left: '50%', transform: 'translateX(-50%)',
        width: 10, height: 8, background: '#1e2010',
        borderRadius: 2,
      }} />
      {/* Paper */}
      <div style={{
        position: 'absolute', top: 14, left: 10, right: 10, bottom: 6,
        background: '#282c18', borderRadius: 2,
      }} />
      {/* Lines */}
      {[20, 28, 36, 44].map(top => (
        <div key={top} style={{
          position: 'absolute', top, left: 13, right: 13, height: 1,
          background: '#404830', opacity: 0.9,
        }} />
      ))}
      {/* Sticky note */}
      <div style={{
        position: 'absolute', top: 16, right: 8, width: 14, height: 14,
        background: '#4a4010', border: '1px solid #6a5a10',
        transform: 'rotate(8deg)',
      }} />
    </div>
  );
}

function CRTShape() {
  return (
    <div style={{ position: 'relative', width: 64, height: 64 }}>
      {/* Monitor body */}
      <div style={{
        position: 'absolute', top: 2, left: 4, right: 4, bottom: 14,
        background: '#181818', borderRadius: 6,
        border: '2px solid #2a2a2a',
        boxShadow: '0 2px 8px rgba(0,0,0,0.7)',
      }} />
      {/* Screen bezel */}
      <div style={{
        position: 'absolute', top: 8, left: 8, right: 8, bottom: 20,
        background: '#0a0a0a', borderRadius: 3,
      }} />
      {/* Screen glow */}
      <div style={{
        position: 'absolute', top: 10, left: 10, right: 10, bottom: 22,
        background: '#001800',
        borderRadius: 2,
        boxShadow: '0 0 8px rgba(0,220,0,0.25), inset 0 0 6px rgba(0,180,0,0.1)',
        overflow: 'hidden',
      }}>
        {/* Scanlines */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.25) 2px, rgba(0,0,0,0.25) 3px)',
        }} />
        {/* Text lines */}
        <div style={{ position: 'absolute', top: 3, left: 2, right: 6, height: 2, background: 'rgba(0,200,0,0.7)', borderRadius: 1 }} />
        <div style={{ position: 'absolute', top: 7, left: 2, right: 10, height: 2, background: 'rgba(0,200,0,0.4)', borderRadius: 1 }} />
        <div style={{ position: 'absolute', top: 11, left: 2, right: 4, height: 2, background: 'rgba(0,200,0,0.3)', borderRadius: 1 }} />
        {/* Cursor */}
        <div style={{ position: 'absolute', top: 11, right: 6, width: 3, height: 3, background: 'rgba(0,200,0,0.8)' }} />
      </div>
      {/* Neck/stand */}
      <div style={{
        position: 'absolute', bottom: 8, left: 26, right: 26, height: 4,
        background: '#242424', borderRadius: 2,
      }} />
      {/* Base */}
      <div style={{
        position: 'absolute', bottom: 2, left: 14, right: 14, height: 8,
        background: '#1c1c1c', borderRadius: 3,
        border: '1px solid #2a2a2a',
      }} />
    </div>
  );
}

const SHAPES = { phone: PhoneShape, ledger: LedgerShape, clipboard: ClipboardShape, crt: CRTShape };

export function DeskObject({ type, label, badge, hasAlert, onClick }) {
  const Shape = SHAPES[type] || (() => null);

  return (
    <div
      onClick={onClick}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        padding: '6px 10px',
        cursor: 'pointer',
        borderRadius: 8,
        transition: 'filter 0.15s ease, background 0.15s ease',
        userSelect: 'none',
        minWidth: 80,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.filter = 'brightness(1.4)';
        e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.filter = 'brightness(1)';
        e.currentTarget.style.background = 'transparent';
      }}
    >
      {/* Alert dot */}
      {hasAlert && (
        <div style={{
          position: 'absolute', top: 4, right: 6,
          width: 10, height: 10, borderRadius: '50%',
          background: 'var(--red)',
          border: '2px solid #1a1612',
          animation: 'desk-pulse 1.5s ease-in-out infinite',
          zIndex: 1,
        }} />
      )}

      <Shape />

      <div style={{ fontSize: 10, color: 'var(--text-muted)', textAlign: 'center', whiteSpace: 'nowrap' }}>
        {label}
      </div>

      {badge != null && (
        <div style={{
          fontSize: 10, fontWeight: 700,
          color: hasAlert ? 'var(--red)' : 'var(--text)',
          background: 'var(--border-light)',
          border: `1px solid ${hasAlert ? 'var(--red-dim)' : 'var(--border)'}`,
          borderRadius: 10,
          padding: '1px 7px',
          whiteSpace: 'nowrap',
        }}>
          {badge}
        </div>
      )}
    </div>
  );
}
